import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EventTrackingService } from '../../../services/event-tracking.service';
import { WindowRefService } from '../../../services/window-ref.service';
import { LinkClick } from 'src/app/models/event-data.model';
import { AuthEventType } from 'src/app/enums/event/event.enum';
import { AuthLinkType } from 'src/app/enums/event/event-data.enum';
import { CreditHealthState } from '../store/credit-health.reducer';

@Injectable({
  providedIn: 'root',
})
export class CreditHealthService {
  constructor(
    private readonly http: HttpClient,
    private readonly cookieService: CookieService,
    private readonly eventTrackingService: EventTrackingService,
    private readonly windowRefService: WindowRefService,
  ) {}

  getCreditHealth(): Observable<CreditHealthState> {
    return this.http.get<CreditHealthState>(`${environment.vantageScore}`, {
      headers: { Authorization: this.cookieService.get('X-Access-Token') },
    });
  }

  navigateToCreditHealth(url: string) {
    this.windowRefService.nativeWindow.FS.event('[Auth] Credit Health Login');
    this.eventTrackingService.trackEvent<LinkClick>(AuthEventType.LINK_CLICK, {
      authClickLinkText: 'Credit Manager',
      authClickLinkType: AuthLinkType.NAV_TO_CREDIT_MANAGER,
    });
    this.windowRefService.nativeWindow.location.href = `${url}&next=/financial-health/credit-manager/`;
  }

  navigateToCreditHealthMoneyManager(url: string) {
    // TODO AWEE-361 - Enterprise Events TBD
    this.eventTrackingService.trackEvent<LinkClick>(AuthEventType.LINK_CLICK, {
      authClickLinkText: 'Money Manager',
      authClickLinkType: AuthLinkType.NAV_TO_MONEY_MANAGER,
    });
    this.windowRefService.nativeWindow.location.href = `${url}&next=/financial-health/money-manager/`;
  }

  navigateToCreditHealthDebtManager(url: string) {
    // TODO AWEE-361 - Enterprise Events TBD
    this.eventTrackingService.trackEvent<LinkClick>(AuthEventType.LINK_CLICK, {
      authClickLinkText: 'Debt Manager',
      authClickLinkType: AuthLinkType.NAV_TO_DEBT_MANAGER,
    });
    this.windowRefService.nativeWindow.location.href = `${url}&next=/financial-health/debt-manager/`;
  }
}
